import {ANALYTICS_SOURCE_TYPES} from '../constants';

function fromAddToCartEvent(data) {
  if (!data?._id || !data?.lineItems?.length) {
    console.warn('Invalid add-to-cart event data:', data);
    return {cartID: '', items: []};
  }

  const cartID = data._id;
  const currency = data.currency;
  return {
    cartID,
    items: data.lineItems.map((item) => {
      const productInfo = {
        sku: item?.materialNumber?.toString(),
        name: item?.productName,
        currency,
        price: item?.price?.toString(),
        qty: item?.quantity,
      };
      return {productInfo};
    }),
  };
}

export const mapAddToCartEvent = (source, options = {}) => {
  if (options.sourceType === ANALYTICS_SOURCE_TYPES.CART) {
    return fromAddToCartEvent(source);
  }
  return source;
};
